"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var UserStore_1 = require("stores/UserStore");
var Notification_1 = require("components/core/Notification");
var QueriesStore_1 = require("stores/QueriesStore");
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var Radios_1 = __importDefault(require("components/core/inputs/Radios"));
var Button_1 = __importDefault(require("components/core/buttons/Button"));
var AuthTable_1 = __importDefault(require("./AuthTable"));
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var TextInput_1 = __importDefault(require("../../../../core/inputs/TextInput"));
var Dialog_1 = require("../../../../core/Dialog");
var use_dialog_1 = require("../../../../../hooks/use-dialog");
var config_1 = __importDefault(require("config"));
var getCurrency = function (country) {
    return country === QueriesStore_1.Countries.IR ? "€" : "£";
};
var toBoolean = function (input) { return input === "true"; };
var FleetQueryStage3 = function (_a) {
    var data = _a.data;
    var _b = use_stores_1.useStores(), queriesStore = _b.queriesStore, userStore = _b.userStore;
    var notification = use_notification_1.useNotification();
    var timeout = react_1.useRef(null);
    var history = react_router_dom_1.useHistory();
    var dialog = use_dialog_1.useDialog();
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var approveHandler = function (e) {
        var authLevel = data.fleetQuery.approvalLevel;
        var validLevel = userStore.levelFleetPermission(authLevel);
        var message = "";
        if (!validLevel) {
            message = "You do not have the correct permissions to approve this query";
        }
        if (!data.fleetQuery.queryReason || data.fleetQuery.queryReason.length <= 0) {
            message = "Please state a query reason before approving";
        }
        if (data.fleetQuery.preventativeAction && !data.fleetQuery.preventativeActionComment ||
            data.fleetQuery.preventativeAction && data.fleetQuery.preventativeActionComment.length <= 0) {
            message = 'Please enter a comment regarding preventative action';
        }
        if (data.fleetQuery.reclaimedFromDealer && !data.fleetQuery.reclaimedFromDealerComment ||
            data.fleetQuery.reclaimedFromDealer && data.fleetQuery.reclaimedFromDealerComment.length <= 0) {
            message = 'Please enter a comment regarding reclamation from dealer';
        }
        if (message.length > 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: message
            });
            return;
        }
        if (!data.fleetQuery.queryReason || data.fleetQuery.queryReason.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please state a query reason before approving"
            });
            return;
        }
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Approve this query?",
            description: "Are you sure you want to approve this query? Please write a comment below with your reasoning",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            var _a;
            api_1.default.sendQueryForward(data.id, (_a = { currentStage: 3 }, _a["level" + authLevel] = true, _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Successfully Approved Query"
                });
            });
        });
    };
    var rejectHandler = function (e) {
        var authLevel = data.fleetQuery.approvalLevel;
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Reject this query?",
            description: "Are you sure you want to reject this query? Please write a comment below with your reasoning",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            var _a;
            api_1.default.sendQueryForward(data.id, (_a = { currentStage: 3 }, _a["level" + authLevel] = false, _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query was rejected"
                });
                history.replace("/");
            });
        });
    };
    var checkAuthExists = function () {
        var authLevel = data.fleetQuery.approvalLevel;
        for (var key in data.fleetQuery) {
            if (data.fleetQuery.hasOwnProperty(key)) {
                if (key.indexOf("Authorisation") > -1) {
                    var level = parseInt(key.match(/\d/g).join(""));
                    if (data.fleetQuery[key] !== null && level === authLevel)
                        return true;
                }
            }
        }
        return false;
    };
    var getTotals = function () {
        var totals = { dr: 0, cr: 0 };
        for (var _i = 0, _a = data.fleetQuery.fleetQueryIPCs; _i < _a.length; _i++) {
            var ipcRow = _a[_i];
            totals.dr += ipcRow.newNet * ipcRow.quantity - ipcRow.itemNet * ipcRow.quantity;
            totals.cr += ipcRow.newNet - ipcRow.itemNet;
        }
        return totals;
    };
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        if (timeout.current !== null)
            clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            var _a;
            api_1.default.patchQuery(data.id, (_a = {},
                _a[name] = value,
                _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query successfully updated"
                });
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error updating query"
                });
            });
        }, 500);
    };
    return (react_1.default.createElement("div", { className: "stage-3-form" },
        react_1.default.createElement("div", { className: "flex flex-roW" },
            react_1.default.createElement("div", { className: "half" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                data.queryStage.stage === 3 &&
                userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                react_1.default.createElement(Select_1.default, { name: "queryReason", value: data.fleetQuery.queryReason || "", onChange: changeHandler, options: Object.keys(QueriesStore_1.FleetQueryReasons).filter(function (key) { return isNaN(parseInt(key)); })
                        .map(function (key) { return ({
                        value: QueriesStore_1.FleetQueryReasons[key],
                        text: QueriesStore_1.FleetQueryReasons[key]
                    }); }) })
                :
                    react_1.default.createElement(InfoRow_1.default, { label: "Query Reason", value: data.fleetQuery.queryReason || "" })),
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(InfoRow_1.default, { label: "Total DR/CR Value", negativeValue: getTotals().dr < 0, value: getTotals().dr.toFixed(2) }))),
        react_1.default.createElement("div", { className: "attachments no-input" },
            react_1.default.createElement("span", { className: "subtitle" }, "Attachments"),
            react_1.default.createElement("ul", null, data.attachments.length <= 0 ?
                react_1.default.createElement("p", null, "There are no attachments")
                :
                    data.attachments.map(function (attachment) { return (react_1.default.createElement("li", { key: attachment.id },
                        react_1.default.createElement("a", { href: config_1.default.api_base + "/attachment/" + attachment.id, title: attachment.fileName }, attachment.fileName))); }))),
        react_1.default.createElement("div", { className: "checkboxes flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Preventative Action Required?", name: "preventativeAction", value: data.fleetQuery.preventativeAction || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Preventative Action Required?", value: data.fleetQuery.preventativeAction ? "Yes" : "No" }),
                data.fleetQuery.preventativeAction &&
                    react_1.default.createElement("div", { className: "hidden-inputs" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryStage.stage === 3 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                        react_1.default.createElement(TextInput_1.default, { type: "text", name: "preventativeActionComment", altLabel: "Preventative Action", defaultValue: data.fleetQuery.preventativeActionComment || "", onKeyUp: keyHandler })
                        :
                            react_1.default.createElement(InfoRow_1.default, { label: "Preventative Action Comment", value: data.fleetQuery.preventativeActionComment || "" })),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Reclaimed from Dealer?", name: "reclaimedFromDealer", value: data.fleetQuery.reclaimedFromDealer || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Reclaimed from Dealer?", value: data.fleetQuery.reclaimedFromDealer ? "Yes" : "No" }),
                data.fleetQuery.reclaimedFromDealer &&
                    react_1.default.createElement("div", { className: "hidden-inputs" }, data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryStage.stage === 3 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_3) ?
                        react_1.default.createElement(TextInput_1.default, { type: "text", name: "reclaimedFromDealerComment", altLabel: "Reclaimed from Dealer Comment", defaultValue: data.fleetQuery.reclaimedFromDealerComment || "", onKeyUp: keyHandler })
                        :
                            react_1.default.createElement(InfoRow_1.default, { label: "Reclaimed from Dealer Comment", value: data.fleetQuery.reclaimedFromDealerComment || "" })),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 3 &&
                    userStore.levelFleetPermission(data.fleetQuery.approvalLevel) ?
                    checkAuthExists() ? null :
                        react_1.default.createElement("div", { className: "approve flex flex-row" },
                            react_1.default.createElement("span", null,
                                "Level ",
                                data.fleetQuery.approvalLevel),
                            react_1.default.createElement(Button_1.default, { type: "button", onClick: approveHandler, title: "Approve" }, "Approve"),
                            react_1.default.createElement(Button_1.default, { type: "button", onClick: rejectHandler, title: "Reject" }, "Reject"))
                    : null),
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(AuthTable_1.default, { data: data.queryAuthorisations })))));
};
exports.default = FleetQueryStage3;
